<template>
  <div class="container">
    <div class="ctn-texto m-b-2">
      <h1 class="titulo m-t-1-sm m-t-3-md">
        Metodología de la Secuenciación Genómica del VIH
      </h1>
      <p>
        El VIH se caracteriza por una alta variabilidad genética. Esta alta
        variabilidad es inherente a su forma de replicación y se asocia
        fuertemente a los errores cometidos por la enzima transcriptasa inversa
        al copiar el genoma viral de ARN a ADN. Cuando una persona adquiere la
        infección, gracias a esta alta capacidad de variación genética, el VIH
        puede adaptarse progresivamente a su sistema inmune, generando
        diversidad genética. Esta diversidad genética finalmente hace que los
        virus de diferentes personas sean ligeramente diferentes entre sí. Así,
        si comparamos qué tan diferentes son los virus de todas las personas
        dentro de una misma población, podemos detectar aquéllos pares que
        tienen un alto grado de similitud o “baja distancia genética”, y con
        esto podemos inferir posibles agrupaciones o cadenas de transmisión.
      </p>
      <p>
        El establecimiento de esta “red genética de transmisión” del VIH,
        requiere que contemos con secuencias genéticas del virus de todas las
        personas que se diagnostican con la infección en una zona geográfica en
        particular. Mientras más personas se incluyan, más completa será la red
        de transmisión inferida.
      </p>
      <p>
        El Centro de Investigación en Enfermedades Infecciosas (CIENI) del
        Instituto Nacional de Enfermedades Respiratorias Ismael Cosío Villegas
        (INER), es un centro acreditado por la Organización Mundial de la Salud
        para la secuenciación de VIH con altos estándares de calidad. Como parte
        de este proyecto de investigación, apoyado con fondos del Conahcyt, el
        CIENI/INER realiza secuenciación de todas las personas con diagnóstico
        reciente de la Clínica Especializada Condesa, el centro de atención
        primaria de VIH más grande de México, situada en la Ciudad de México. Se
        utilizan métodos de secuenciación de siguiente generación que han sido
        validados internamente y que cumplen con múltiples filtros de calidad
        para la emisión final de los resultados. En breve, a partir de muestras
        de sangre de las personas que participan voluntariamente en el estudio,
        se obtiene la fracción líquida o plasma. A partir del plasma, se extrae
        el ARN del virus.
      </p>
      <p>
        Los blancos moleculares de interés en el genoma del virus, en particular
        los genes que codifican para la proteasa, transcriptasa inversa e
        integrasa virales se copian a ADN y amplifican para luego fraccionarse e
        incorporarse a un proceso de secuenciación masiva. En este proceso, se
        producen simultáneamente cientos de miles de lecturas por cada virus
        analizado. Estas lecturas o secuencias cortas genéticas se ensamblan
        para obtener una secuencia consenso final de los genes de interés del
        virus de cada persona. Las secuencias genéticas consenso se utilizan
        para inferir la red genética de transmisión.
      </p>
      <p>
        La red genética de transmisión se realiza a través de un programa
        desarrollado por colaboradores de la Universidad de California en San
        Diego, y que ha sido adaptado para las necesidades específicas de este
        proyecto, llamado “Seguro HIV-TRACE”. Este programa analiza la distancia
        genética (homología) de todas las secuencias de los virus a estudiar,
        asignando como posibles pares de transmisión a todos aquéllos que tengan
        una distancia genética igual o menor a 1.5%.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      expandido: undefined,
    };
  },
};
</script>

<style lang="scss" scoped>
.lista-metodologia {
  .item {
    display: flex;
    span {
      font-size: 30px;
      font-weight: bold;
      color: #989898;
      margin-right: 5px;
      min-width: 40px;
    }
    p {
      margin-top: 4px;
      margin-bottom: 8px;
      ol {
        list-style-type: lower-alpha;
        margin-block: 20px;
      }
    }
  }
  @media (min-width: map-get($media-queries-limit, "mobile")) {
    display: grid;
    grid-auto-flow: column;
    grid-column-gap: 40px;
    .item {
      flex-direction: column;
      span {
        font-size: 40px;
        color: #000000;
        border-bottom: 2px solid #414141;
        margin-right: 0;
      }
    }
  }
}
</style>
